import { useTests } from '@/ab-tests/client/use-tests';
import { mapCookiesToHeadersValue } from '@/ab-tests/utils';
import { getBaseAxiosInstance } from '@/api/axios-instances';
import type { Response } from '@/basket/types/response';
import { useSiteId } from '@/contexts/domain/hooks';
import type { AxiosInstance, AxiosResponse } from 'axios';
import { useLocale } from 'next-intl';

export type ApiFn<TResponse, TParams extends unknown[] = []> = (
  axiosInstance: AxiosInstance,
  ...params: TParams
) => Promise<AxiosResponse<Response<TResponse>>>;

export const useBaseApiCall = <TResponse, TParams extends unknown[] = []>(
  callFn: ApiFn<TResponse, TParams>,
) => {
  const cookieTest = useTests();
  const siteId = useSiteId();
  const testHeaders = mapCookiesToHeadersValue(
    JSON.stringify(cookieTest),
    siteId,
  );
  const axiosInstance = getBaseAxiosInstance(useLocale(), siteId, testHeaders);

  return async (...params: TParams) =>
    (await callFn(axiosInstance, ...params)).data.data;
};
